<template>
  <i :class="componentClassName"></i>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export const ICON_SHAPES = [
  'arrow-left',
  'audio-play',
  'audio-pause',
  'audio-backward',
  'audio-forward',
  'bell',
  'bell-outline',
  'building',
  'calendar-setting',
  'calendar-outline',
  'calendar',
  'caret-down',
  'caret-right',
  'caret-up',
  'check',
  'check-large',
  'chevron-left',
  'chevron-right',
  'clock-remove',
  'clock',
  'close',
  'code',
  'credit-card',
  'download',
  'edit',
  'eye',
  'eye-slash',
  'file',
  'file-outline',
  'filter',
  'fullscreen',
  'gear',
  'gear-outline',
  'help',
  'help-outline',
  'home-outline',
  'home',
  'list-outline',
  'list',
  'lock',
  'logout-outline',
  'minus',
  'minimize',
  'numpad',
  'play',
  'phone-call-1',
  'phone-call-2',
  'phone-call-3',
  'phone-call-active-outline',
  'phone-call-active',
  'phone-call-onhold',
  'phone-call-transfer',
  'phone-call-history-outline',
  'phone-call-history',
  'phone-incoming-call',
  'phone-incoming-call-outline',
  'phone-incoming-call-block',
  'phone-hang-up-call',
  'phone-missed-call',
  'phone-missed-call-outline',
  'phone-outgoing-call',
  'phone-outgoing-call-outline',
  'phone-over-flow',
  'phone-receive-call',
  'phone-reject-call',
  'phone-setting',
  'plus',
  'register',
  'search',
  'sms-phone',
  'sms-setting',
  'sound',
  'star',
  'star-outline',
  'upload',
  'user-operator',
  'user-outline',
  'user-setting',
  'user',
  'trash',
];

export const ICON_COLORS = ['black', 'orange', 'green', 'white', 'grey', 'red', 'yellow', 'blue'];

export default {
  name: 'a-vdxb-icon',
  props: {
    icon: {
      type: String,
      required: true,
      validator(value) {
        return ICON_SHAPES.indexOf(value) !== -1;
      },
    },
    color: {
      type: String,
      default: null,
      validator(value) {
        return ICON_COLORS.indexOf(value) !== -1 || value === null;
      },
    },
  },
  computed: {
    componentClassName() {
      return mapModifiers('a-icon', this.icon, this.color);
    },
  },
};
</script>
